import React, { useState } from "react";
import { getDatabase, ref, set } from "firebase/database"; // Import Firebase

const BookRecommendation = ({ restaurantID }) => {
    const [bookName, setBookName] = useState("");
    const [authorName, setAuthorName] = useState("");
    const [error, setError] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!bookName && !authorName) {
            setError("Please enter either a book name or an author name.");
            return;
        }

        const db = getDatabase();
        const unixTimestampMillis = Date.now();
        const recommendationsRef = ref(db, `s9book_recommendations/${unixTimestampMillis}`);

        set(recommendationsRef, {
            book: bookName || "Unknown Book",
            author: authorName || "Unknown Author",
            timestamp: new Date().toISOString(),
        });

        window.gtag("event", `s9 Book Recommendation Book Addition Recommendation Submit`, {
            'restaurant': restaurantID,
            'timestamp': new Date().toISOString(),
            book: bookName || "Unknown Book",
            author: authorName || "Unknown Author"
        });

        setError("");
        setSubmitted(true);
        setTimeout(() => {
            setSubmitted(false);
            setBookName("");
            setAuthorName("");
        }, 3000);
    };


    return (
        <>
            {/* Book Recommendation Form */}
            < div style={styles.container}>
                <h2 style={styles.title}>Book Addition Recommendation</h2>
                <p style={styles.subtitle}>Share a book or author you love! </p>

                {submitted ? (
                    <p style={styles.success}>✅ Thanks for your recommendation!</p>
                ) : (
                    <form onSubmit={handleSubmit} style={styles.form}>
                        <input
                            type="text"
                            placeholder="Book Name"
                            value={bookName}
                            onChange={(e) => setBookName(e.target.value)}
                            style={styles.input}
                        />
                        <input
                            type="text"
                            placeholder="Author Name"
                            value={authorName}
                            onChange={(e) => { window.gtag("event", `${restaurantID}_Book Addition Recommendation Interaction`, { 'restaurant': restaurantID, 'event': `Book Addition Recommendation Interaction`, 'timestamp': new Date().toISOString() }); setAuthorName(e.target.value) }}
                            style={styles.input}
                        />
                        {error && <p style={styles.error}>{error}</p>}
                        <button type="submit" style={styles.button}>Submit</button>
                    </form>
                )}
            </div>
        </>

    );
};

// Inline styles
const styles = {
    container: {
        width: "92vw",
        height: "fit-content",
        margin: "2vw 0vw 5vw 0px",
        padding: "30px",
        textAlign: "center",
        background: "#FFFFFF",
        borderRadius: "30px",
        boxShadow: "0px 0px 25px #24242430"
    },
    title: { fontSize: "26px", fontWeight: "900", color: "#242424", height: "fit-content", margin: '0px 0px 5px 0px' },
    subtitle: { fontSize: "16px", color: "#666", height: "fit-content", margin: '0px 0px 10px 0px' },
    form: { display: "flex", flexDirection: "column", gap: "10px", marginTop: "15px" },
    input: {
        padding: "15px",
        fontSize: "16px",
        borderRadius: "15px",
        border: "1px solid #ccc",
    },
    button: {
        padding: "15px",
        fontSize: "16px",
        background: "#242424",
        color: "#fff",
        border: "none",
        borderRadius: "15px",
        cursor: "pointer",
    },
    error: { color: "red", fontSize: "14px" },
    success: { color: "green", fontSize: "16px", fontWeight: "bold" },
};

export default BookRecommendation;
